import styled from "styled-components";

const FeaturesCardStyleWrapper = styled.article`
  .features_card {
    background: #131740;
    max-width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 40px 20px;
    border-radius: 10px;
    border : 1px solid #FF06B7;

    .features_img{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: #FF06B7;
      margin-bottom: 10px;

      span {
        font-size: 36px;
        line-height: 36px;
        color: #FFF;
      }
    }


    h3 {
      color: #ffffff;
      font-size: 22px;
      line-height: 34px;
      text-align: center;
      margin-top: 8px;
      margin-bottom: 10px;
    }

    h4 {
      font-family: "Poppins";
      font-style: normal;
      text-align: center;
      font-size: 14px;
      line-height: 22px;
      color: rgba(255, 255, 255);
      margin: 0;
    }
  }

  @media only screen and (max-width: 991px) {
    .features_card {
      h3 {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
`;

export default FeaturesCardStyleWrapper;
